import { DropdownItemRenderV2 } from "#src/commonV2/antdHelpers/DropdownItemRender";
import { DropdownRenderV2 } from "#src/commonV2/antdHelpers/DropdownRender";
import { FormCoreInput } from "#src/commonV2/form/core/CoreInput";
import { FormInputWrapper } from "#src/commonV2/form/helpers/InputWrapper";
import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";
import { Dropdown } from "@lockerpm/design";
import { ChevronDown, XCircle } from "@untitled-ui/icons-react";

interface ISocialProfileItemProps {
  value: string;
  onChangeValue: (value: string) => void;
  selected: IFilterItemV2;
  onChangeSelected: (value: IFilterItemV2) => void;
  options: IFilterItemV2[];
  onRemove: () => void;
}

export const SocialProfileItem = ({
  value,
  onChangeValue,
  selected,
  onChangeSelected,
  options,
  onRemove,
}: ISocialProfileItemProps) => {
  const syncWidthId = "social-dropdown-";

  // --------------- COMPUTED ---------------

  // --------------- RENDER ---------------

  return (
    <FormInputWrapper invalid={false} id={syncWidthId}>
      <Dropdown
        menu={{
          items: options.map((item) => ({
            key: item.key,
            label: (
              <DropdownItemRenderV2
                label={
                  <>
                    {item.leftIcon ? item.leftIcon : null}
                    {item.getLabel()}
                  </>
                }
                isSelected={item.key === selected.key}
                compact
              />
            ),
          })),
          onClick: ({ key }) => {
            const selected = options.find((item) => item.key === key);
            if (selected) {
              onChangeSelected(selected);
            }
          },
        }}
        dropdownRender={(menu) => (
          <DropdownRenderV2 syncWidthId={syncWidthId}>{menu}</DropdownRenderV2>
        )}
        trigger={["click"]}
      >
        <div className="flex justify-between items-center gap-1 text-md text-gray-v2-700 py-2 pl-3 min-w-[4.5rem]">
          {selected ? selected.getLabel() : <span />}
          <ChevronDown className="h-5 w-5 min-w-5 text-gray-v2-400" />
        </div>
      </Dropdown>
      <div className="flex items-center gap-2 pl-2.5 pr-3 py-2 flex-1">
        <FormCoreInput
          value={value}
          onChange={(e) => {
            onChangeValue(e.target.value);
          }}
        />
        <span
          className="cursor-pointer h-full flex items-center"
          onClick={onRemove}
        >
          <XCircle className="w-4 h-4 text-gray-v2-400" />
        </span>
      </div>
    </FormInputWrapper>
  );
};
